"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./EnterprisePromotionCta.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-923":{"id":"e-923","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-924"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f01a535b-83a4-0be7-dccb-080b993207aa","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f01a535b-83a4-0be7-dccb-080b993207aa","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1732555546207},"e-925":{"id":"e-925","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-926"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f01a535b-83a4-0be7-dccb-080b993207ac","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f01a535b-83a4-0be7-dccb-080b993207ac","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732555546207},"e-927":{"id":"e-927","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-928"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f01a535b-83a4-0be7-dccb-080b993207cb","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f01a535b-83a4-0be7-dccb-080b993207cb","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"BOTTOM","effectIn":true},"createdOn":1732555546207},"e-929":{"id":"e-929","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-930"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f01a535b-83a4-0be7-dccb-080b993207ae","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f01a535b-83a4-0be7-dccb-080b993207ae","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1732555546207},"e-1076":{"id":"e-1076","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1077"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f01a535b-83a4-0be7-dccb-080b993207a6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f01a535b-83a4-0be7-dccb-080b993207a6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":90,"direction":"BOTTOM","effectIn":true},"createdOn":1732814778424},"e-1078":{"id":"e-1078","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-1079"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0d51ca46-eebb-6107-5569-bc21455d6544","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0d51ca46-eebb-6107-5569-bc21455d6544","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":250,"direction":"BOTTOM","effectIn":true},"createdOn":1732814798374}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function EnterprisePromotionCta({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "enterprisepromotion_section-cta")}
      tag="section"
      grid={{
        type: "section",
      }}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-bottom-xxlarge")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "enterprisepromotion_cta-card",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "enterprisepromotion_cta-content",
                  "align-center",
                  "content-align-center"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "enterprisepromotion_cta-copy-wrap"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "enterprisepromotion_cta-badge-container"
                    )}
                    data-w-id="f01a535b-83a4-0be7-dccb-080b993207a6"
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "badge", "is-green")}
                      tag="div"
                    >
                      <_Builtin.Block tag="div">
                        {"LIMITED TIME OFFER"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "enterprisepromotion_cta-heading",
                      "heading-style-h4",
                      "text-align-center"
                    )}
                    data-w-id="f01a535b-83a4-0be7-dccb-080b993207aa"
                    tag="div"
                  >
                    {"Enterprise Plan: "}
                    <_Builtin.Span
                      className={_utils.cx(
                        _styles,
                        "enterpriseplan_cta-header-copy-highlight"
                      )}
                    >
                      {"Save 30%"}
                    </_Builtin.Span>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "enterprisepromotion_cta-description",
                      "text-align-center"
                    )}
                    data-w-id="f01a535b-83a4-0be7-dccb-080b993207ac"
                    tag="div"
                  >
                    {
                      "Canada's safest rental platform is having their annual holiday sale. Claim your savings before its too late!"
                    }
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Link
                  className={_utils.cx(
                    _styles,
                    "button-2",
                    "is-secondary",
                    "is-ghost"
                  )}
                  data-w-id="0d51ca46-eebb-6107-5569-bc21455d6544"
                  button={true}
                  id="bf_30offenterprise_get30off_click"
                  block=""
                  options={{
                    href: "#",
                  }}
                >
                  {"Get 30% off"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "disclaimer-container",
                "padding-xsmall",
                "align-center",
                "max-width-large"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "text-size-tiny",
                  "text-color-tertiary",
                  "disclaimer"
                )}
                tag="div"
              >
                {
                  "* By signing up, you will receive 30% off liv.rent's Enterprise Plan for one year. After the first year, regular charges will apply. You can cancel at any time. "
                }
                <_Builtin.Link
                  className={_utils.cx(_styles, "disclaimer-link")}
                  button={false}
                  block=""
                  options={{
                    href: "/terms",
                    target: "_blank",
                  }}
                >
                  {"View terms & conditions"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
